import axiosInstance from "../utils/axios";

export const announcementService = {
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get("/announcement", {
      params,
    });
    return response.data;
  },
  findById: async (id) => {
    const response = await axiosInstance.get(`/announcement/${id}`);
    return response.data;
  },
  store: async (data) => {
    const isFormData = data instanceof FormData;
    const response = await axiosInstance.post("/announcement", data, {
      ...(isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {}),
    });
    return response.data;
  },
  update: async (id, data) => {
    const isFormData = data instanceof FormData;
    const response = await axiosInstance.put(`/announcement/${id}`, data, {
      ...(isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {}),
    });
    return response.data;
  },
  delete: async (id) => {
    const response = await axiosInstance.delete(`/announcement/${id}`);
    return response.data;
  },
};

export default announcementService;
